// extracted by mini-css-extract-plugin
export default {"wrapper":"BooksCountBlock_wrapper__lBEJG","countBlock":"BooksCountBlock_countBlock__170TF"};